import React, { useEffect, useState } from 'react';
import { Button } from 'onefaceui-react-components';
import PropTypes from 'prop-types';

import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { getResourceTo } from 'react/utils/utils';

export function UnlockButton({ grid }) {
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const unblockUsersRequest = async (ids) => {
    setIsLoading(true);
    await defaultFetch('User/Unlock', ids, 'POST');

    const filter = App.Objects.Users.getFilter();

    Monet.Grid.Utils.clearPagination('Users');
    App.Objects.Users.updateGrid(filter, Monet.Grid.addDataToGrid, false);
    App.Forms.Users.table.setSelectedRows([]);
    setIsLoading(false);
  };

  const handleClick = async () => {
    const selectedItems = grid.getItemsSelected();
    const usersId = selectedItems.map(({ attributes }) => attributes.id);

    new Greenmile.Components.AlertModal(
      getResourceTo('users.alert.message.restore'),
      getResourceTo('users.alert.title.restore'),
      () => unblockUsersRequest(usersId)
    ).show();
  };

  const onSelectRow = (_, args) => {
    const selectedItems = args.grid.getItemsSelected();

    if(selectedItems.length === 0) {
      setIsDisabled(true);
      return;
    }

    const shouldShowMenu = selectedItems?.every(
      ({ attributes }) => !!attributes.lockDate || !!attributes.expireDate
    );

    if (shouldShowMenu) {
      setIsDisabled(false);
      return;
    }

    setIsDisabled(true);
  };

  useEffect(() => {
    grid.onSelectedRowsChanged.subscribe(onSelectRow);

    return () => {
      grid.onSelectedRowsChanged.unsubscribe(onSelectRow);
    };
  }, []);

  return (
    <Button
      disabled={isDisabled}
      onClick={handleClick}
      loading={isLoading}
      variant="secondary"
      id="user-unblock-button"
    >
      {getResourceTo('users.grid.button.unblock')}
    </Button>
  );
}

UnlockButton.propTypes = {
  grid: PropTypes.object.isRequired
};
